export const FETCH_REFERRALS_SUCCESS = 'FETCH_REFERRALS_SUCCESS';
export const FETCH_REFERRALS_FAIL = 'FETCH_REFERRALS_FAIL';
export const FETCH_REFERRALS_START = 'FETCH_REFERRALS_START';

export const ADD_REFERRAL_START = 'ADD_REFERRAL_START';
export const ADD_REFERRAL_SUCCESS = 'ADD_REFERRAL_SUCCESS';
export const ADD_REFERRAL_FAIL = 'ADD_REFERRAL_FAIL';
